/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Badge } from '../models/Badge';
import type { Body_put_image_api_v1_images__ldap__jpg_put } from '../models/Body_put_image_api_v1_images__ldap__jpg_put';
import type { Employee } from '../models/Employee';
import type { EmployeeCard } from '../models/EmployeeCard';
import type { EmployeeEventSubscriptionEventType } from '../models/EmployeeEventSubscriptionEventType';
import type { EmployeeEventSubscriptionState } from '../models/EmployeeEventSubscriptionState';
import type { EmployeeLocation } from '../models/EmployeeLocation';
import type { EmployeeMap } from '../models/EmployeeMap';
import type { EmployeeWithHierarchy } from '../models/EmployeeWithHierarchy';
import type { EmployeeWithSearchMetadata } from '../models/EmployeeWithSearchMetadata';
import type { PeoplePage } from '../models/PeoplePage';
import type { PeopleSearchRankingMode } from '../models/PeopleSearchRankingMode';
import type { ProfilePage } from '../models/ProfilePage';
import type { UpdateEmployeeTeam } from '../models/UpdateEmployeeTeam';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmployeeService {

    /**
     * Get Self
     * @returns Employee Successful Response
     * @throws ApiError
     */
    public static getSelfApiV1PeopleSelfGet(): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/self',
        });
    }

    /**
     * All Employee Endpoint
     * @param ldap
     * @returns EmployeeCard Successful Response
     * @throws ApiError
     */
    public static getCardApiV1PeopleLdapCardGet(
        ldap: string,
    ): CancelablePromise<EmployeeCard> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/{ldap}/card',
            path: {
                'ldap': ldap,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * All Employee Endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getTreeAllApiV1PeopleTreeGet(): CancelablePromise<(EmployeeWithHierarchy | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/tree',
        });
    }

    /**
     * People Page Endpoint
     * @param currentDate
     * @returns PeoplePage Successful Response
     * @throws ApiError
     */
    public static getPeopleApiV1PeopleGet(
        currentDate?: (string | null),
    ): CancelablePromise<PeoplePage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people',
            query: {
                'current_date': currentDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Employees Endpoint
     * @param ldap
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getImageApiV1ImagesLdapJpgGet(
        ldap: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/images/{ldap}.jpg',
            path: {
                'ldap': ldap,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Employees Endpoint
     * @param ldap
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static putImageApiV1ImagesLdapJpgPut(
        ldap: string,
        formData: Body_put_image_api_v1_images__ldap__jpg_put,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/images/{ldap}.jpg',
            path: {
                'ldap': ldap,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Search Endpoint
     * @param name
     * @param limit
     * @param rankingMode
     * @returns EmployeeWithSearchMetadata Successful Response
     * @throws ApiError
     */
    public static searchPeopleApiV1PeopleSearchGet(
        name: string,
        limit: number = 50,
        rankingMode?: (PeopleSearchRankingMode | null),
    ): CancelablePromise<Array<EmployeeWithSearchMetadata>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/search',
            query: {
                'name': name,
                'limit': limit,
                'ranking_mode': rankingMode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit Teams
     * @param ldap
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static editTeamsApiV1PeopleLdapTeamsPut(
        ldap: string,
        requestBody: Array<UpdateEmployeeTeam>,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/people/{ldap}/teams',
            path: {
                'ldap': ldap,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * LDAP Endpoint
     * @param ldap
     * @returns Employee Successful Response
     * @throws ApiError
     */
    public static getEmployeeByLdapApiV1PeopleLdapLdapGet(
        ldap: string,
    ): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/ldap/{ldap}',
            path: {
                'ldap': ldap,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * LDAPS Endpoint
     * @param requestBody
     * @returns Employee Successful Response
     * @throws ApiError
     */
    public static getEmployeesByLdapsApiV1PeopleLdapsPost(
        requestBody: Array<string>,
    ): CancelablePromise<Array<Employee>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/people/ldaps',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Location
     * @param location
     * @returns EmployeeLocation Successful Response
     * @throws ApiError
     */
    public static locationApiV1PeopleLocationLocationGet(
        location: string,
    ): CancelablePromise<Array<EmployeeLocation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/location/{location}',
            path: {
                'location': location,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * City
     * @param city
     * @returns EmployeeLocation Successful Response
     * @throws ApiError
     */
    public static cityApiV1PeopleCityCityGet(
        city: string,
    ): CancelablePromise<Array<EmployeeLocation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/city/{city}',
            path: {
                'city': city,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Nearby Cities
     * @param city
     * @returns EmployeeLocation Successful Response
     * @throws ApiError
     */
    public static nearbyCitiesApiV1PeopleNearbyCitiesCityGet(
        city: string,
    ): CancelablePromise<Array<EmployeeLocation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/nearby_cities/{city}',
            path: {
                'city': city,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Profile Endpoint
     * @param userId
     * @returns ProfilePage Successful Response
     * @throws ApiError
     */
    public static getProfileApiV1PeopleUserIdGet(
        userId: string,
    ): CancelablePromise<ProfilePage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Subscribe To Employee Event
     * @param userId
     * @param eventType
     * @returns EmployeeEventSubscriptionState Successful Response
     * @throws ApiError
     */
    public static subscribeToEmployeeEventApiV1PeopleUserIdEventSubscriptionsEventTypePut(
        userId: string,
        eventType: EmployeeEventSubscriptionEventType,
    ): CancelablePromise<EmployeeEventSubscriptionState> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/people/{user_id}/event-subscriptions/{event_type}',
            path: {
                'user_id': userId,
                'event_type': eventType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Unsubscribe From Employee Event
     * @param userId
     * @param eventType
     * @returns EmployeeEventSubscriptionState Successful Response
     * @throws ApiError
     */
    public static unsubscribeFromEmployeeEventApiV1PeopleUserIdEventSubscriptionsEventTypeDelete(
        userId: string,
        eventType: EmployeeEventSubscriptionEventType,
    ): CancelablePromise<EmployeeEventSubscriptionState> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/people/{user_id}/event-subscriptions/{event_type}',
            path: {
                'user_id': userId,
                'event_type': eventType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Badges
     * @param userId
     * @returns Badge Successful Response
     * @throws ApiError
     */
    public static getBadgesApiV1PeopleUserIdReceivedGet(
        userId: string,
    ): CancelablePromise<Array<Badge>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/people/{user_id}/received',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Employee Map
     * @returns EmployeeMap Successful Response
     * @throws ApiError
     */
    public static getEmployeeMapApiV1EmployeeMapGet(): CancelablePromise<Array<EmployeeMap>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee/map',
        });
    }

}
